import React, { memo } from "react";
import BlitzMark from "../../../assets/images/blitz-mark.svg";
import styles from "./manage.module.css";

// Rider-to-door loop from "Manage Order.dc.html" (4.8s cycle). Decorative only.
const PlanScene = ({ arriving }) => (
  <div className={styles.scene}>
    <div className={styles.road} />
    <div className={styles.house}>
      <span className={styles.pin}>
        <svg width="22" height="28" viewBox="0 0 24 30" aria-hidden="true">
          <path d="M12 0C5.4 0 0 5.2 0 11.7 0 20.5 12 30 12 30s12-9.5 12-18.3C24 5.2 18.6 0 12 0z" fill="#7130F0" />
          <circle cx="12" cy="11.5" r="4.5" fill="#fff" />
        </svg>
      </span>
      <svg width="64" height="58" viewBox="0 0 64 58" className={styles.houseSvg} aria-hidden="true">
        <path d="M6 26L32 5l26 21v32H6z" fill="#fff" stroke="#1B3B6F" strokeWidth="2.5" strokeLinejoin="round" />
        <path d="M2 29L32 4l30 25" fill="none" stroke="#7130F0" strokeWidth="3.5" strokeLinecap="round" strokeLinejoin="round" />
        <rect x="25" y="34" width="14" height="24" rx="2" fill="#7130F0" />
        <circle cx="35.5" cy="46" r="1.4" fill="#fff" />
      </svg>
      <span className={styles.doorGlow} />
      <span className={styles.ripple} />
    </div>
    <div className={styles.rider}>
      <svg width="72" height="64" viewBox="-40 -64 72 66" className={styles.riderSvg} aria-hidden="true">
        <ellipse cx="0" cy="1" rx="26" ry="3.5" fill="#1B3B6F" opacity=".16" />
        <g className={styles.wheel}>
          <g transform="scale(.9)">
            <rect x="-37" y="-51" width="25" height="23" rx="3.5" fill="#111827" />
            <image href={BlitzMark} x="-35.5" y="-50" width="22" height="21" />
            <path d="M-9 -31 L-5 -45" stroke="#111827" strokeWidth="9" strokeLinecap="round" />
            <path d="M-4 -43 L15 -36" stroke="#111827" strokeWidth="4" strokeLinecap="round" />
            <circle cx="-3" cy="-53" r="5.5" fill="#111827" />
            <path d="M-8.5 -54 A5.5 5.5 0 0 1 2.5 -54 Z" fill="#7130F0" />
            <path d="M-28 -9 C-29 -19 -22 -25 -10 -25 L3 -25 C5 -25 5 -21 4 -18 L4 -13 L13 -13 L18 -36 L22 -36 L19 -17 C24 -15 27 -11 27 -9 Z" fill="#7130F0" />
            <rect x="-21" y="-30" width="21" height="5.5" rx="2.75" fill="#111827" />
            <path d="M-8 -30 L5 -29 L8 -15" fill="none" stroke="#111827" strokeWidth="5.5" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M14 -37 L24 -37" stroke="#111827" strokeWidth="3" strokeLinecap="round" />
            <circle cx="22.5" cy="-32" r="2" fill="#FFD166" />
            <path d="M-24 -16 L-6 -16" stroke="#fff" strokeWidth="1.6" strokeLinecap="round" opacity=".7" />
            <circle cx="-17" cy="-7" r="7" fill="#111827" />
            <circle cx="-17" cy="-7" r="2.5" fill="#fff" />
            <circle cx="19" cy="-7" r="7" fill="#111827" />
            <circle cx="19" cy="-7" r="2.5" fill="#fff" />
          </g>
        </g>
      </svg>
    </div>
    <div className={styles.arriving}>
      <span className={styles.arrivingLabel}>Arriving</span>
      <span className={styles.arrivingDate}>{arriving}</span>
    </div>
  </div>
);

export default memo(PlanScene);
